import api from './api'

export default {
  getDepartamentos: async () => {
    const response = await api
      .get('/api/select-department')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getTags: async () => {
    const response = await api
      .get('/api/select-tag-option')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getStatusRuler: async (id) => {
    const response = await api
      .get(`/api/select-status-ruler/${id}`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getClassificationKanban: async (params) => {
    const response = await api
      .get(`/api/select-tab-classification`, {
        params
      })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getRegisterKanban: async (params) => {
    const response = await api
      .get(`/api/select-tab-by-status`, {
        params
      })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  setSaveStatus: async (id, data) => {
    const response = await api
      .put(`/api/update-select-status-ruler/${id}`, data)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getTagsExists: async () => {
    const response = await api
      .get('/api/select-tag-option-exists')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getProductPurchased: async () => {
    const response = await api
      .get('/api/select-product-purchased')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getProductInterest: async () => {
    const response = await api
      .get('/api/select-product-interest')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getCampaignInterest: async () => {
    const response = await api
      .get('/api/select-campaign-interest')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getFiliais: async () => {
    const response = await api
      .get('api/select-subsidiary')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getRecordClassification: async (ficha_id) => {
    const response = await api
      .get('api/select-tab-classification', { params: { ficha_id } })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getReasonRefusal: async (id) => {
    const response = await api
      .get(`api/select-reason-refusal/${id}`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getRulerStatus: async (id) => {
    const response = await api
      .get('/api/select-ruler-status', { params: { id } })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  // Réguas de atendimento com seus status, numa chamada só.
  // Usado pela condição "Régua de Status" do Se/Então da Automação.
  getAutomationReguaStatus: async () => {
    const response = await api
      .get('/api/select-automation-regua-status')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getRulerStatusByReguaId: async (regua_id) => {
    const response = await api
      .get('/api/select-ruler-status', { params: { regua_id } })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getStatusRulerWithParam: async (id) => {
    const response = await api
      .get('/api/select-status-ruler', { params: { id } })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getTypeActivity: async (params) => {
    const response = await api
      .get('api/select-type-activity', { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getStatusActivity: async () => {
    const response = await api
      .get('api/select-status-activity')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getTabType: async () => {
    const response = await api
      .get('api/select-tab-type')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getClassificationType: async () => {
    const response = await api
      .get('api/select-classificacao')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getStatus: async () => {
    const response = await api
      .get('api/select-status')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getLeads: async () => {
    const response = await api
      .get('api/select-type-lead')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getResponsibilities: async () => {
    const response = await api
      .get('api/select-responsibilitie')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getTeamLeaders: async () => {
    const response = await api
      .get('api/select-team-leader')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getLeadDuplicated: async () => {
    const response = await api
      .get('api/select-action-lead-duplicated')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getCodExportDiscador: async () => {
    const response = await api
      .get('api/select-sip-code')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getCodTabulaRecebida: async () => {
    const response = await api
      .get('api/select-voll-tabulations')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getUf: async () => {
    const response = await api
      .get('api/select-uf')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getLastOrigin: async () => {
    const response = await api
      .get('api/select-last-origin')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getOrigin: async (params) => {
    const response = await api
      .get('api/select-lead-entry-origin', { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getLeadCampaign: async (params) => {
    const response = await api
      .get('api/select-lead-campaign', { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  createCampaign: async (data) => {
    const response = await api
      .post('/api/create-campaign', data)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getSocialClass: async () => {
    const response = await api
      .get('api/select-social-class')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getCampaign: async (params) => {
    const response = await api
      .get(`api/select-campaign`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getRoulette: async (typeLead) => {
    const response = await api
      .get(`api/select-roulletes/${typeLead}`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getRuler: async (params) => {
    const response = await api
      .get(`api/select-ruler`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getTeam: async (params) => {
    const response = await api
      .get(`api/select-team`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getOperator: async (params) => {
    const response = await api
      .get(`api/select-operator`, {
        params
      })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getOperatorAssessor: async (params) => {
    const response = await api
      .get(`api/select-operator?tipo=assessor`, {
        params
      })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getOperatorHunter: async (params) => {
    const response = await api
      .get(`api/select-operator?tipo=hunter`, {
        params
      })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getBatchImport: async (params) => {
    const response = await api
      .get(`api/select-lote-importacao`, {
        params
      })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getRouletteType: async () => {
    const response = await api
      .get(`api/select-roulette-type`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getAssessorByQueue: async (id) => {
    const response = await api
      .get(`api/select-assessor-queue/${id}`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getLeadOrigin: async (id) => {
    const response = await api
      .get(`api/select-lead-origin${id ? `?regua_id=${id}` : ''}`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getHolidays: async () => {
    const response = await api
      .get(`api/select-holiday`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getResponsability: async () => {
    const response = await api
      .get(`api/select-remove-responsability`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getAssessors: async (params) => {
    const response = await api
      .get(`api/select-acessor`, {
        params
      })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getHunters: async (params) => {
    const response = await api
      .get(`api/select-hunter`, {
        params
      })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getHsm: async (params) => {
    const response = await api
      .get(`/api/select-hsm`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getLibertaPlayCategorias: async () => {
    const response = await api
      .get('/api/liberta-play/categorias')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getLibertaPlayProdutos: async (categoriaId) => {
    const response = await api
      .get(`/api/liberta-play/produtos/${categoriaId}`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getLibertaPlayPeriodos: async (produtoId) => {
    const response = await api
      .get(`/api/liberta-play/periodos/${produtoId}`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getHsmMedia: async (params) => {
    const response = await api
      .get(`/api/select-hsm-media`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getCampaingActive: async (params) => {
    const response = await api
      .get(`api/select-whatsapp-campaign`, {
        params
      })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getBaseInputType: async () => {
    const response = await api
      .get(`api/select-base-input-type`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getBaseInputTypeSlug: async () => {
    const response = await api
      .get(`api/select-base-input-type-slug`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getCardStatus: async () => {
    const response = await api
      .get('/api/select-status-ficha')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getTab: async (regua_id) => {
    const response = await api
      .get('/api/select-tab', { params: { regua_id } })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getQueue: async (regua_id) => {
    const response = await api
      .get('/api/select-queue', { params: { regua_id } })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getHsmType: async (params) => {
    const response = await api.get(`api/select-hsm-type`, {
      params
    })

    return response
  },
  getAllHunters: async () => {
    const response = await api
      .get('/api/select-all-hunters')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getAllAcessors: async () => {
    const response = await api
      .get('/api/select-all-acessors')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getRecordrulerStatus: async (id) => {
    const response = await api
      .get(`/api/select-record-ruler-status/${id}`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getOrderOptions: async () => {
    const response = await api
      .get('/api/select-order-leads')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getType: async () => {
    const response = await api
      .get('/api/select-configuration-type-responsible-removal-service')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getTypeOperetor: async () => {
    const response = await api
      .get('/api/select-operator-type')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getTypeOrigin: async () => {
    const response = await api
      .get('/api/select-lead-entry-origin-lp')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getTypeOriginAll: async () => {
    const response = await api
      .get('/api/select-lead-entry-origin')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getResponsibleRemovalOptions: async () => {
    const response = await api
      .get('/api/select-responsible-removal-options')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getStatusBulkChange: async (rulerId) => {
    const response = await api
      .get(`/api/select-ruler-status-bulk-change/${rulerId}`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getCluster: async (id) => {
    const response = await api
      .get(`/api/select-cluster${id ? `?regua_id=${id}` : ''}`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getClusterForMailing: async (regua_id) => {
    const response = await api
      .get(`/api/select-cluster`, { params: { regua_id } })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getFieldType: async () => {
    const response = await api
      .get(`/api/select-field-type`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getFieldTable: async () => {
    const response = await api
      .get(`/api/select-table`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getStatusLeadLp: async () => {
    const response = await api
      .get(`/api/select-status-lead-lp`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getUtmObjetivo: async () => {
    const response = await api
      .get(`/api/select-utm-objetivo`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getTeamRuler: async () => {
    const response = await api
      .get(`api/select-team-rulers`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getResponsible: async () => {
    const response = await api
      .get(`api/select-responsible-removal-action`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getLeadOriginClone: async () => {
    const response = await api
      .get(`/api/select-lead-origin-clone`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getStatusPaymentOptions: async () => {
    const response = await api
      .get(`/api/select-status-pagamento`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getAreaExibicao: async () => {
    const response = await api
      .get(`/api/select-display-area`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getOrigem: async () => {
    const response = await api
      .get(`/api/select-field-origin`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getFormato: async () => {
    const response = await api
      .get(`/api/select-field-format`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getTabelaRelacionamento: async () => {
    const response = await api
      .get(`/api/select-table-relationship`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getCampoChaveExibicao: async (slug) => {
    const response = await api
      .get(`/api/select-field-relationship/${slug}`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getCampo: async (params) => {
    const response = await api
      .get(`/api/select-field`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getSelectRulerCsv: async () => {
    const response = await api
      .get(`/api/select-ruler-csv/`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getSelectPhoneValidationOrigin: async () => {
    const response = await api
      .get(`/api/select-phone-config-validation-origem`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getDays: async () => {
    const response = await api
      .get(`/api/select-base-input-day`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getSelectGrouperSlug: async () => {
    const response = await api
      .get(`/api/select-grouper-slug`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getSelectStatusGrouper: async () => {
    const response = await api
      .get(`/api/select-status-grouper`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getSelectOptionsForms: async () => {
    const response = await api
      .get(`/api/select-form`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getRulerTeam: async (params) => {
    const response = await api
      .get(`api/select-ruler-team`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getSelectApi: async () => {
    const response = await api
      .get(`/api/select-endpoint`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getDinamicSelect: async (id, params) => {
    const response = await api
      .get(`/api/api-endpoints/execute/${id}`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getConfigCloneSelect: async () => {
    const response = await api
      .get(`/api/select-clonagem-ficha-configuracoes`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getSelectActivityClient: async (id, params) => {
    const response = await api
      .get(`/api/select-activity-client/${id}`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getLeadsExclusiveImport: async () => {
    const response = await api
      .get(`api/select-lead-origin-importacao`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getRelatoriosBi: async () => {
    const response = await api
      .get(`api/select-relatorios-bi`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  listSelectQueueUser: async () => {
    const response = await api
      .get('/api/select-queue-user')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getSelectFamilyGroup: async () => {
    const response = await api
      .get(`api/select-family-group`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getSelectBanks: async () => {
    const response = await api
      .get(`api/select-bank`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getMovimentacaoType: async () => {
    const response = await api
      .get(`/api/select-movement-type`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getPipeType: async () => {
    const response = await api
      .get(`/api/select-pipe`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  listMovimentation: async (id) => {
    const response = await api
      .get(`/api/list-bancos-ficha-movement/${id}`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  listCustody: async (id) => {
    const response = await api
      .get(`/api/list-bancos-ficha-custodia/${id}`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  getTypesSelect: async () => {
    const response = await api
      .get(`/api/select-responsibilitie`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getSquad: async () => {
    const response = await api
      .get(`/api/select-squad`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getTagAssessor: async () => {
    const response = await api
      .get(`/api/select-tag-assessor`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getActiveSeniority: async () => {
    const response = await api
      .get(`/api/select-seniorities`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getActiveIndicators: async () => {
    const response = await api
      .get(`/api/select-pds-indicator`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getActiveScopes: async () => {
    const response = await api
      .get(`/api/select-pds-scope`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getActiveFinancialClass: async () => {
    const response = await api
      .get(`/api/select-pds-financial-class`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getActiveFinancialSubclass: async () => {
    const response = await api
      .get(`/api/select-pds-financial-subclass`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getRevenueMatrixRelatorioXp: async (params) => {
    const response = await api
      .get(`/api/select-pds-revenue-matrix-relatorio-xp`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getRevenueMatrixProdutoCategoria: async (params) => {
    const response = await api
      .get(`/api/select-pds-revenue-matrix-produto-categoria`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getRevenueMatrixLinhaReceita: async (params) => {
    const response = await api
      .get(`/api/select-pds-revenue-matrix-linha-receita`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getRevenueMatrixClasseAtivo: async (params) => {
    const response = await api
      .get(`/api/select-pds-revenue-matrix-classe-ativo`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getRevenueMatrixSubclasseAtivo: async (params) => {
    const response = await api
      .get(`/api/select-pds-revenue-matrix-subclasse-ativo`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getRevenueMatrixReceitaComissoes: async (params) => {
    const response = await api
      .get(`/api/select-pds-revenue-matrix-receita-comissoes`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getGoals: async () => {
    const response = await api
      .get(`/api/select-pds-goal`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getUserGoal: async () => {
    const response = await api
      .get(`/api/select-pds-goal-usuarios`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getUserRevenueMatrix: async () => {
    const response = await api
      .get(`/api/select-pds-revenue-matrix-usuarios`)
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  getEmailTemplate: async (params) => {
    const response = await api
      .get(`/api/select-email-template`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  // Origens de entrada disponíveis para o cadastro manual (usado no Consórcio).
  getLeadOriginManualRegistration: async (params) => {
    const response = await api
      .get(`/api/select-lead-origin-manual-registration`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  },
  // Labels/valores em pt-BR de situacao, status_regua, modalidade_lance e status_carta.
  /**
   * Catálogos do bloco de consórcio. Com `regua_id` a resposta traz também
   * `campos`, que diz quais campos aquela régua exibe e quais exige; sem o
   * parâmetro vem a configuração padrão (tudo ativo, só o valor da carta
   * obrigatório).
   */
  getConsortiumOptions: async (params) => {
    const response = await api
      .get(`/api/select-consortium-options`, { params })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)
    return response
  }
}
